import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Overlayable} from "../../interfaces/overlayable";
import {SchoolSubjectsFilterData} from "./school-subjects-filter-data";
import {Store} from "@ngrx/store";
import {AppState} from "../../store";
import {
  setUpdateArchiveView,
  toggleJobFilterValue,
  toggleSelectedSchoolSubject
} from "../../store/actions/filter.actions";
import {getFilterByKey} from "../../store/selectors/filter.selector";
import {SchoolSubjectsFilterItem} from "./school-subjects-filter-item";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
  selector: 'brt-school-subjects-filter',
  templateUrl: './school-subjects-filter.component.html',
  styleUrls: ['./school-subjects-filter.component.scss']
})
export class SchoolSubjectsFilterComponent implements OnInit, Overlayable, SchoolSubjectsFilterData, OnDestroy {

  @Output('onClosed') onClosed = new EventEmitter<boolean>();
  @Input('options') set setOptions(val: SchoolSubjectsFilterItem[]) {
    this.options = val;

    if(this.options.length % 3 === 0) {
      this.itemsPerRow = 3;
    }
  };

  @Input('filterKey') filterKey!: string;
  options: SchoolSubjectsFilterItem[] = [];

  itemsPerRow = 4;

  constructor(
    private store: Store<AppState>
  ) {
  }
  ngOnInit() {
    this.store.select(getFilterByKey(this.filterKey)).pipe(untilDestroyed(this)).subscribe((val) => {
      this.options = this.options.map(el => {
        el.active = val.indexOf(el.filterValue) !== -1
        return el;
      });
    });
  }

  ngOnDestroy() {
    this.store.dispatch(setUpdateArchiveView({updateActive: true}));
  }

  toggleFilter(filterItem: SchoolSubjectsFilterItem) {
    this.store.dispatch(toggleJobFilterValue({key: this.filterKey, value: filterItem.filterValue}));
  }
}
